import { render, staticRenderFns } from "./Primary.vue?vue&type=template&id=a6c6cd90&"
import script from "./Primary.vue?vue&type=script&lang=js&"
export * from "./Primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6c6cd90')) {
      api.createRecord('a6c6cd90', component.options)
    } else {
      api.reload('a6c6cd90', component.options)
    }
    module.hot.accept("./Primary.vue?vue&type=template&id=a6c6cd90&", function () {
      api.rerender('a6c6cd90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/layout/sidebarComponents/Primary.vue"
export default component.exports